import RecordingBaseView from '@/pages/recordings/index.vue'
import RecordingList from '@/pages/recordings/list.vue'
import ProgramEdit from '@/pages/recordings/programs/edit.vue'
import ProgramList from '@/pages/recordings/programs/list.vue'
import StreamEdit from '@/pages/recordings/streams/edit.vue'
import StreamList from '@/pages/recordings/streams/list.vue'

export default {
  path: '/recordings/',
  redirect: '/recordings/list',
  name: 'Recordings',
  component: RecordingBaseView,
  children: [
    {
      path: 'list',
      name: 'RecordingList',
      component: RecordingList,
    },
    {
      path: 'streams/list',
      name: 'StreamList',
      component: StreamList,
    },
    {
      path: 'streams/create',
      name: 'StreamCreate',
      component: StreamEdit,
    },
    {
      path: 'streams/:id/edit',
      name: 'StreamEdit',
      component: StreamEdit,
    },
    {
      path: 'programs/list',
      name: 'ProgramList',
      component: ProgramList,
    },
    {
      path: 'programs/create',
      name: 'ProgramCreate',
      component: ProgramEdit,
    },
    {
      path: 'programs/:id/edit',
      name: 'ProgramEdit',
      component: ProgramEdit,
    },
  ],
}
